import { render, staticRenderFns } from "./PartnerEditor.vue?vue&type=template&id=4b13701c&scoped=true"
import script from "./PartnerEditor.vue?vue&type=script&lang=js"
export * from "./PartnerEditor.vue?vue&type=script&lang=js"
import style0 from "./PartnerEditor.vue?vue&type=style&index=0&id=4b13701c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13701c",
  null
  
)

export default component.exports